import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import handle401 from '../handle-401';
import HttpClient from '../../Api/HttpClient';

export const taskGroupsListQuery = () =>
  queryOptions({
    gcTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    queryKey: ['flow-group-list'],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getTaskGroups();

      return data.map((taskGroup) => ({
        id: taskGroup.id,
        label: taskGroup.label,
        category: taskGroup.category,
        active: taskGroup.active,
        department: taskGroup.department,
        color: taskGroup.color,
      }));
    }),
  });

export const taskGroupQuery = ({ flowGroupId }) =>
  queryOptions({
    queryKey: ['flow-group', flowGroupId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getTaskGroup({ id: flowGroupId });

      return {
        id: data[0].id,
        label: data[0].label,
        category: data[0].category,
        department: data[0].department,
        color: data[0].color,
        active: data[0].active,
        flows: data[0].linked_flows.map((flow) => {
          return {
            linkId: flow.id,
            flowId: flow.document_type,
            flowLabel: flow.flow_details.custom_label,
            taskGroupId: flow.task_group,
            startDate: flow.start_date,
            endDate: flow.end_date,
            offset: flow.offset,
            timing: flow.task_timing,
            timingReferenceLink: flow.timing_ref_lnk,
            referencedFlowId: data[0].linked_flows.find((link) => link.id === flow.timing_ref_lnk)
              ?.document_type,
          };
        }),
      };
    }),
  });
